// Le hook de validation de session unique et les deux aides pour lire ou
// fabriquer son jeton ont disparu avec la connexion multi-appareils
// simultanée (`7e0e4af5d`) : plus aucun appelant depuis, la seconde n'étant
// déjà plus qu'un no-op conservé pour ne rien casser. Ne restent ici que
// `SessionInvalidReason` (type partagé par `AuthContext.tsx` et
// `lib/sessionLogout.ts`) et `clearSessionToken` (efface encore les
// anciennes clés au moment de la déconnexion).

const SESSION_TOKEN_KEY = 'flowcut_session_token';
const SESSION_TOKEN_SET_AT_KEY = 'flowcut_session_token_at';

export type SessionInvalidReason = 'session_replaced' | 'session_expired' | 'no_token' | 'jwt_expired';

/**
 * Clear the session token from localStorage.
 * Call this on logout.
 */
export function clearSessionToken(): void {
  localStorage.removeItem(SESSION_TOKEN_KEY);
  localStorage.removeItem(SESSION_TOKEN_SET_AT_KEY);
}
